import React from 'react';

const Footer = () => {
	return (
		<React.Fragment>
			<footer>
				<hr />
				Developed by
				<a href='https://arunabharjun.com' target='_blank'>
					{' '}
					Arunabh Arjun
				</a>
			</footer>
		</React.Fragment>
	);
};

export default Footer;
